const RecruitingEmploymentContractType = {
  Regular: "REGULAR",
  Contract: "CONTRACT",
  Dispatch: "DISPATCH",
  Freelancer: "FREELANCER",
  Intern: "INTERN",
  PartTime: "PART_TIME"
};

export { RecruitingEmploymentContractType };
//# sourceMappingURL=recruiting-employment-contract-type.mjs.map
